import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import UserForm from './form/index';
import './styles.scss';

class UsersEdit extends Component {
  componentDidMount() {
    const {dealerId, code, username, isUserFromTDE} = this.props;

    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.UsersList,
        scopes.Create
      ) ||
      !hasAccessPermission(
        this.props.permissions,
        resources.UsersList,
        scopes.Edit
      )
    ) {
      this.props.push(paths.AccessDenied);
    }

    this.props.clearUserForm();
    this.props.fetchUsersPolicies();
    if (!username && !code) {
      this.props.setUserField('dealer', dealerId);

      if (isUserFromTDE) {
        this.props.fetchUsersfromDirectory();
        this.props.setUserTdeNew();
      }
    } else if (code) {
      this.props.fetchUserRequestInfo(code);
    } else if (username) {
      this.props.fetchUserByParams(username, {'detail': 'S'});
    }
  }

  componentDidUpdate(prevProps) {
    const {dealer, userSession, agenciesList} = this.props;

    if (!agenciesList.length && prevProps.dealer !== dealer) {
      this.props.fetchAgenciesByDealer({'dealerId': dealer});
    }
    if (prevProps.user !== userSession) {
      this.props.setUserField('user', userSession);
    }
  }

  componentWillUnmount() {
    this.props.clearUserForm();
    this.props.clearAgenciesList();
  }

  onSubmit = async(formValues) => {
    const {code, push, username, isUserFromTDE, dealer, dealerId, isTdeUserNew} = this.props;
    const {status} = formValues;
    const isTdeUser = isUserFromTDE && dealer === dealerId;
    const userId = username || formValues?.username;
    
    if (!code && !status) {
      await this.props.addNewUserRequest(formValues);
    } else if (username || (isTdeUser && !isTdeUserNew)) {
      await this.props.updateUser(userId, {isTdeUser}, formValues);
    } else if (status === 'A' || (isTdeUser && isTdeUserNew)) {
      await this.props.addNewUser(code, isTdeUserNew, {isTdeUser}, formValues);
    } else {
      await this.props.updateUserRequest(code, formValues);
    }
    push(paths.UsersList);
  }

  render() {
    const {code, push, dealerId, username} = this.props;

    return (
      <UserForm
        push={push}
        code={code}
        username={username}
        dealerId={dealerId}
        onSubmit={this.onSubmit}
      />
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    'code': ownProps.params.code || state.userForm.id,
    'agenciesList': state.dealer.agenciesList,
    'username': ownProps.params.username,
    'dealerId': state.session.dealerId,
    'userSession': state.session.user,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'isUserFromTDE': state.session.isUserFromTDE,
    'isTdeUserNew': state.userForm.isTdeUserNew,
    'dealer': state.userForm.values.dealer,
    'user': state.userForm.values.user,
  };
};

const {
  fetchUsersfromDirectory,
  addNewUserRequest,
  updateUserRequest,
  clearUserForm,
  setUserField,
  addNewUser,
  updateUser,
  setUserTdeNew,
  fetchUserByParams,
  fetchAgenciesByDealer,
  fetchUserRequestInfo,
  fetchUsersPolicies,
  clearAgenciesList,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    clearUserForm,
    fetchUserRequestInfo,
    fetchAgenciesByDealer,
    fetchUsersPolicies,
    setUserTdeNew,
    setUserField,
    fetchUserByParams,
    addNewUser,
    updateUser,
    addNewUserRequest,
    updateUserRequest,
    clearAgenciesList,
    fetchUsersfromDirectory,
  })(UsersEdit)
);
